'use client';

import React, { useState } from 'react';
import Header from '@/components/Header';
import PropertyListings from './components/PropertyListings';
import Reservations from './components/Reservations';
import Earnings from './components/Earnings';
import HostCalendar from './components/HostCalendar';
import Ratings from './components/Ratings';
import PayoutRequests from './components/PayoutRequests';
import PropertyAvailability from './components/PropertyAvailability';
import EarningsAnalytics from './components/EarningsAnalytics';
import PayoutMethods from './components/PayoutMethods';

const navItems = [
  { id: 'listings', label: 'Properties', icon: '🏠' },
  { id: 'reservations', label: 'Reservations', icon: '📅' },
  { id: 'earnings', label: 'Earnings', icon: '💰' },
  { id: 'analytics', label: 'Analytics', icon: '📊' },
  { id: 'calendar', label: 'Calendar', icon: '🗓️' },
  { id: 'availability', label: 'Availability', icon: '🔓' },
  { id: 'ratings', label: 'Ratings', icon: '⭐' },
  { id: 'payouts', label: 'Payouts', icon: '💳' },
  { id: 'payout-methods', label: 'Payout Methods', icon: '🏧' },
];

export default function HostDashboardPage() {
  const [activeSection, setActiveSection] = useState('listings');

  const renderSection = () => {
    switch (activeSection) {
      case 'listings': return <PropertyListings />;
      case 'reservations': return <Reservations />;
      case 'earnings': return <Earnings />;
      case 'analytics': return <EarningsAnalytics />;
      case 'calendar': return <HostCalendar />;
      case 'availability': return <PropertyAvailability />;
      case 'ratings': return <Ratings />;
      case 'payouts': return <PayoutRequests />;
      case 'payout-methods': return <PayoutMethods />;
      default: return <PropertyListings />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          {/* Dashboard Header */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900" style={{ fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
              Host Dashboard
            </h1>
            <p className="text-gray-500 mt-1 text-sm">Manage your properties, reservations, and earnings</p>
          </div>

          {/* Tab Navigation */}
          <div className="flex gap-1 bg-white rounded-2xl p-1.5 shadow-sm border border-gray-100 mb-8 overflow-x-auto">
            {navItems?.map((item) => (
              <button
                key={item?.id}
                onClick={() => setActiveSection(item?.id)}
                className={`flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold whitespace-nowrap transition-all duration-200 flex-1 justify-center ${
                  activeSection === item?.id
                    ? 'bg-[#4088C6] text-white shadow-sm'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                }`}
              >
                <span>{item?.icon}</span>
                <span>{item?.label}</span>
              </button>
            ))}
          </div>

          {/* Section Content */}
          <div>{renderSection()}</div>
        </div>
      </div>
    </div>
  );
}
